import { Heart, MessageCircle, Share2, Trash2 } from "lucide-react"
import PollComponent from "./PollComponent"
import { useState } from "react"

const SubPost = ({ post, onDeleteSubPost }) => {
    const [isLiked, setIsLiked] = useState(post.isLike)
    const [likesCount, setLikesCount] = useState(post.totalLikes || post.totalLike)

    const handleLike = () => {
        setIsLiked(!isLiked)
        setLikesCount(prev => isLiked ? prev - 1 : prev + 1)
    }

    return (
        <article className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100 mb-6">
            <div className="flex justify-between items-center">
                <h2 className="text-lg md:text-xl font-bold px-6 pt-6 text-gray-900 leading-tight">
                    {post.title}
                </h2>
                <Trash2 className="text-red-500 mx-4 mt-2 cursor-pointer" onClick={() => onDeleteSubPost(post?._id)} />
            </div>

            {post.imgUrl && (
                <div className="px-6 py-4">
                    <div className="relative rounded-xl overflow-hidden">
                        {post?.postMediaType === 'video' ? (
                            <video
                                controls
                                poster={post?.thumbImgUrl || "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"}
                                className="w-full h-72 object-contain"
                                src={post?.imgUrl || "https://upload.wikimedia.org/wikipedia/commons/d/d1/Image_not_available.png"}
                                onContextMenu={(e) => e.preventDefault()} // Disables right-click menu
                                disablePictureInPicture
                                controlsList="nodownload noplaybackrate"
                            >
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            < img
                                src={post.imgUrl}
                                alt={post.title}
                                className="w-full h-72 object-contain bg-gray-50"
                            />
                        )}
                    </div>
                </div>
            )}

            <div className="px-6 pb-4">
                <p className="text-base leading-relaxed text-gray-700">
                    {post.desc}
                </p>
            </div>

            {post.postPolls && post.postPolls.length > 0 && (
                <div className="px-6">
                    {post.postPolls.map(poll => (
                        <PollComponent key={poll._id} poll={poll} />
                    ))}
                </div>
            )}

            <div className="border-t border-gray-100 px-6 py-4">
                <div className="flex items-center justify-between">
                    <div className="flex items-center gap-6">
                        <button
                            className={`flex items-center gap-2 transition-colors ${isLiked ? 'text-red-600' : 'text-gray-600 hover:text-red-600'
                                }`}
                        >
                            <Heart className={`w-5 h-5 ${isLiked ? 'fill-current' : ''}`} />
                            <span className="text-sm font-medium">{likesCount} Likes</span>
                        </button>
                        <div className="flex items-center gap-2 text-gray-600">
                            <MessageCircle className="w-5 h-5" />
                            <span className="text-sm font-medium">{post.totalComment} Comments</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flex items-center gap-3 px-6 pb-4 border-t border-gray-100 pt-4">
                <img
                    src={post.user?.profileImage || `https://ui-avatars.com/api/?name=${post.user?.fullName}&background=random`}
                    alt={post.user?.fullName}
                    className="w-8 h-8 rounded-full"
                />
                <div>
                    <p className="text-sm font-semibold text-gray-900">{post.user?.fullName}</p>
                    <p className="text-xs text-gray-500">
                        {post.user?.isExpert && '⭐ Expert • '}
                        {post.user?.followers} followers
                    </p>
                </div>
            </div>
        </article>
    )
}

export default SubPost;